import React from 'react';
import ProfileInfo from '../../pages/components/profile-info';

export interface SaListPageShellProps {
  /** Short label in the sticky top bar (e.g. "Companies"). */
  topBarTitle: string;
  children: React.ReactNode;
}

/**
 * EMS list-page chrome for Super Admin: top bar row + grey canvas + white panel slot.
 * Put `.dash-list-toolbar` and table content inside `children` (typically `.dash-frame-parent1`).
 */
export function SaListPageShell({ topBarTitle, children }: SaListPageShellProps) {
  return (
    <div className="dash-frame-parent sa-list-page-root sa-modal-host">
      <div className="dash-frame-group">
        <div className="dash-dashboard-wrapper">
          <div className="dash-dashboard">{topBarTitle}</div>
        </div>
        <ProfileInfo />
      </div>

      <div className="dash-frame-wrapper">
        <div className="dash-frame-div sa-list-page">{children}</div>
      </div>
    </div>
  );
}

export default SaListPageShell;
